/**
 * LOLA Context Provider
 *
 * Provides context about what page the user is on so LOLA knows what to operate on
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LoLAContextType {
  businessId: string | null;
  setBusinessId: (id: string | null) => void;
  pageContext: string | null;
  setPageContext: (ctx: string | null) => void;
  availableAgents: any[] | null;
  setAvailableAgents: (agents: any[] | null) => void;
}

const LoLAContext = createContext<LoLAContextType | undefined>(undefined);

export const LoLAContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [businessId, setBusinessId] = useState<string | null>(null);
  const [pageContext, setPageContext] = useState<string | null>(null);
  const [availableAgents, setAvailableAgents] = useState<any[] | null>(null);

  return (
    <LoLAContext.Provider value={{ businessId, setBusinessId, pageContext, setPageContext, availableAgents, setAvailableAgents }}>
      {children}
    </LoLAContext.Provider>
  );
};

export const useLoLAContext = () => {
  const context = useContext(LoLAContext);
  if (context === undefined) {
    throw new Error('useLoLAContext must be used within a LoLAContextProvider');
  }
  return context;
};
